import React, { useState } from "react";
import "../styles/contact.css";
import { IoPersonOutline } from "react-icons/io5";
import { SiMinutemailer } from "react-icons/si";
import { IoCallOutline } from "react-icons/io5";
import { PiSpotifyLogoThin } from "react-icons/pi";
import { AiOutlineMessage } from "react-icons/ai";
import TransparentNav from "../components/TransparentNav";
import Footer from "../components/Footer";
import PinkBgBtn from "../components/PinkBgBtn";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

// comment
const Contact = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { hash } = useLocation();
  const [formData, setFormData] = useState({
    sender: "",
    sender_name: "",
    phone: "",
    subject: "",
    body: ""
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/messages/`, formData, {
        headers: {
          "Content-Type": "application/json",
          "Product-Key": process.env.REACT_APP_PRODUCT_KEY
        }
      });
      if (response.status === 201) {
        setFormData({
          sender: "",
          sender_name: "",
          phone: "",
          subject: "",
          body: ""
        });
        alert("Message sent successfully!");
        return;
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message. Please try again later.");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);
  return (
    <div className="main-contact-container">
      <TransparentNav logo="/images/logo.png" />
      <section className="team-contact">
        <div className="contact-main-container container padding-container">
          <div className="img-text">
            <h1>Healing First Begins With Connection</h1>
            <p>
              Your thoughts and inquiries are important to us, and we’re here to
              help. Please use the form below to send us a message, and we’ll
              get back to you as soon as possible.
            </p>
          </div>
        </div>
      </section>

      <section className="contact-section" id="contact-us">
        <div className="container padding-container">
          <h1>Contact Us</h1>
          <div className="main-contact-container">
            <div className="first-container">
              <p>
                At FirstMed, we care about you and want to make sure you have an
                exceptional experience when you come to us for care.
              </p>
              <div className="pink-container">
                <p>
                  Please do not submit medical questions, personal health
                  information and financial information through this form or
                  email. If this is a life threatening emergency, please call
                  911 immediately.
                </p>
              </div>
            </div>
            <div className="second-container">
              <p>
                Your comments and suggestions help us improve our patient care
                services. If you want to discuss your experience as a patient or
                visitor, please feel free to email us or use the form below to
                let us know your thoughts.
              </p>
              <form action="#" className="form-container">
                <div className="row">
                  <div className="input-row">
                    <IoPersonOutline className="person contact-icon" />
                    <input
                      value={formData.sender_name}
                      onChange={handleChange}
                      type="text"
                      id="sender_name"
                      name="sender_name"
                      placeholder="Full Name"
                    />
                  </div>
                  <div className="input-row">
                    <SiMinutemailer className="mail contact-icon" />
                    <input
                      value={formData.sender}
                      onChange={handleChange}
                      autoComplete="email"
                      type="text"
                      id="sender"
                      name="sender"
                      placeholder="Email"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="input-row">
                    <IoCallOutline className="phone contact-icon" />
                    <input
                      value={formData.phone}
                      onChange={handleChange}
                      autoComplete="tel"
                      type="text"
                      id="phone"
                      name="phone"
                      placeholder="Phone Number"
                    />
                  </div>
                  <div className="input-row">
                    <PiSpotifyLogoThin className="spotify contact-icon" />
                    <input
                      value={formData.subject}
                      onChange={handleChange}
                      autoComplete="off"
                      type="text"
                      id="subject"
                      name="subject"
                      placeholder="Reason For Contacting"
                    />
                  </div>
                </div>
                <div className="input-row">
                  <AiOutlineMessage className="message contact-icon" />
                  <textarea
                    value={formData.body}
                    onChange={handleChange}
                    id="body"
                    name="body"
                    placeholder="Enter your message"
                    rows={10}
                  ></textarea>
                </div>
                <button onClick={handleSubmit} type="button">
                  {isLoading ? "Sending..." : "Send message"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer logo="/images/logo.png" />
    </div>
  );
};

export default Contact;
